import { GridCellChangeRequest } from '.';

export class GridCell {
  id!: string;
  value!: any;
  valueRef!: any;
  isValid!: boolean;
  updatedAt!: Date;
  valueTasks!: GridCellChangeRequest[];
  errors!: string[];
  vtCount!: number;
  etCount!: number;
  tExists!: boolean;
  canDoVt!: boolean;
}
